<script lang="ts">
    import { loginFlowLoading } from './store/loginFlow';
</script>

<div class="loading-wrapper" class:is-loading={$loginFlowLoading}>
    <div class="loading-dots">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
    </div>
</div>

<style lang="scss">
    .loading-wrapper {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 9999;
        width: 100vw;
        height: 100vh;
        display: none;

        &.is-loading {
            display: block;
            user-select: none;
        }

        .loading-dots {
            position: absolute;
            left: 50%;
            top: 40%;
            transform: translate(-50%, -50%);
            width: 1.48rem;
            height: 1.48rem;
            border-radius: 0.4rem;
            background: rgba(37, 38, 45, 0.9);
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.12rem;

            .dot {
                width: 0.12rem;
                height: 0.12rem;
                background: #cccccc;
                border-radius: 50%;
                flex-shrink: 0;
                animation: dot-highlight 0.9s ease-in-out infinite;
            }

            .dot:nth-child(1) {
                animation-delay: 0s;
            }

            .dot:nth-child(2) {
                animation-delay: 0.3s;
            }

            .dot:nth-child(3) {
                animation-delay: 0.6s;
            }
        }
    }

    @keyframes dot-highlight {
        0%,
        100% {
            background: #cccccc;
        }

        33.33% {
            background: #fafafa;
        }

        66.66% {
            background: #cccccc;
        }
    }
</style>
